export const API_CONSTANTS: any = {
  // Finance
  bankAccountStatements: "users/{userId}/finance/account-statements",
  statementDetails: "users/{userId}/finance/statement-detail",
  earningStatements: "users/{userId}/finance/dealerearningspdf",
  bankDetails: "users/{userId}/finance/bankAcc",
  deletebankDetails: "users/{userId}/finance/deleteAcc",
  getAddedBankAccount:
    "users/{userId}/finance/addAcc?accountNumber={accountNumber}&currency={currency}&fields=DEFAULT&customerUid={userId}",
  invoiceSearch: "users/{userId}/invoices/invoice-inquiry",
  creditMemoSearch: "users/{userId}/invoices/getCreditMemos",
  invoiceDetails: "users/{userId}/invoices/invoice-details?invoiceNumber=",
  invoiceDetailsList: "users/{userId}/invoices/invoice-details",
  searchInvoice:
    "users/{userId}/invoices/invoice-inquiry?fields=DEFAULT&orderby=DESC&page=0&sort=invoiceNumber",
  invoicePdfDownload: "users/{userId}/invoices/invoice-pdf",
  receivables: "users/{userId}/finance/my-receivables",
  recentPayments: "users/{userId}/finance/recent-payments",
  dailyPaymentReport: "users/{userId}/finance/download-report",
  scheduledPayments: "users/{userId}/finance/schedulepayment",
  onlinePayments: "users/{userId}/finance/onlinepayments",
  suspendedPayments: "users/{userId}/finance/suspendedpayment",
  cancelScheduledPayment: "users/{userId}/finance/update/schedule-to-cancel",
  cancelSuspendedPayment: "users/{userId}/finance/update/suspend-to-cancel",
  scheduleToSuspend: "users/{userId}/finance/update/schedule-to-suspend",
  suspendToSchedule: "users/{userId}/finance/update/suspend-to-schedule",
  createSchedulePayment: "users/{userId}/finance/schedule-payment",
  createSuspendPayment: "users/{userId}/finance/suspend-payment",
  editBankAccount: "users/{userId}/finance/updateAcc",
  getCreditAnalyst: "users/{userId}/finance/my-creditAnalyst?accountNumber=",
  billPaySignUpUser:
    "users/{userId}/finance/invoice-signup/select-user?customerUid={userId}&fields=DEFAULT",
  invoiceSignUp:
    "users/{userId}/finance/invoice-signup",
  unsettledPayment: "users/{userId}/finance/have-unsettled-payment",
  //
  order: "users/{userId}/getOrderDetailsForOrderCode?orderCode={code}",
  orderHistory: "users/{userId}/orders",
  claim: "users/{userId}/claim",
  claimHistory: "users/{userId}/claim/my-claims",
  claimDetails: "users/{userId}/claim/claim-detail",
  customers: "users/{userId}/orgCustomers",
  getCustomersList: "users/{userId}/orgCustomers/findCustomers",
  registerCustomer: "users/{userId}/orgCustomers/register",
  csrAccountsEdit: "users/{userId}/orgCustomers/editUserByCsr",
  productSearch: "products/search?",
  productSuggestions: "products/search?",
  plpList: "categories/",
  plpSearch: "products/search",
  defaultShippingAddress: "users/",
  allAddress: "users/",
  addressCount:"/users/{userId}/getAllAddressesCount",
  sampleBudgetAllocation: "sample-budget-allocation",
  pdpData: "products/",
  productMedias: "products/{productCode}/productMedias?fields=FULL",
  productPriceDetails: "products/{productCode}/productPriceDetails?fields=FULL",
  cartData: "users/{userId}/carts/{cartId}?fields=DEFAULT",
  checkAvailability: "users/{userId}/atpCheck",
  createCart: "users/{userId}/carts",
  addToCart: "carts/{cartId}/users/{userId}/addToCart",
  checkAvailabilityAPI: "checkAvailability/atpCheck?fields=DEFAULT",
  quotesCreates: "users/{userId}/quotes/createQuoteCart",
  actionQuoto: "users/{userId}/quotes/{quoteId}/quoteActions",
  allAccessory: "products/getalldisplaytypes/{productId}",
  allAccessoryData: "products/getallaccessories/{productId}",
  createQuote: "users/{userId}/quotes/createQuoteCart",
  setCartDetails: "cart/{cartId}/{userId}/addToCart",
  addressesValidate: "users/{userId}/carts/{cartId}/addresses/validate",
  addressesValidatesDetails: "users/{userId}/carts/{cartId}/addresses/validate",
  userDetailing: "orgUsers/",
  cartEntries: "users/{userId}/carts/{cartId}?fields=DEFAULT",
  getAllAccessoryTypes: "products/getalldisplaytypes/",
  UOMDetails: "products/{productId}/productUOMDetails?fields=FULL",
  UserDisable: "/users/anonymous/orgCustomers/disable?userId=",
  userEnable: "/users/anonymous/orgCustomers/enable?userId=",
  removeItemFromCart: "users/{userId}/carts/{cartId}/entries/{entryNumber}",
  removeAllFromCart: "users/{userId}/carts/{cartId}/entries/null",
  placeOrder: "users/{userId}/orders?cartId={cartId}",
  reserveList: "reserve/users/{userId}",
  customerDetail: "{userId}/orgCustomers/",
  getUserInfo: "authorizationserver/oauth/token",
  getReserveNumberDetail: "reserve/{reserveNumber}/getReserveDetails",
  // cancelReserve: "reserve/{reserveNumber}/cancelReserve",
  cancelReserve: "reserve/cancelReserve",
  extendReserve: "reserve/extendReserve",
  reservesExtension: "reserve/extendReserve",
  proceedToCheckout: "users/{userId}/carts/{cartId}/orderReview",
  cartToCheckout: "users/{userId}/carts/{cartId}/checkout",
  submitOrder: "{userId}/{cartId}/submitOrder",
  removeItemsFromCart:
    "users/{userId}/quotes/{quoteCode}/{entryNumber}/quoteEntryRemove?fields=DEFAULT",
  miniCart: "users/{uid}/{customerNumber}/miniCart",
  salesTeam: "account/{customerNumber}/salesTeam",
  checkReserveEligibility: "reserve/checkReserveEligibility/{cartId}",
  shippingAddressValidate: "users/{uid}/carts/{cartNumber}/addresses/validate",
  builderOrder: "users/{userId}/carts/{cartId}/getBuilderInfo",
  placeReserve: "reserve/createReserve/{cartId}/{reserveName}",
  cancelReserveCase: "reserve/cancelReserve",
  poValidation: "{cartID}/validatePO?poNumber={poNumber}",
  submittedFor: "users/{userId}/submittedForList",
  createNewUser: "users/{userId}/carts/{cartId}/createSubmittedFor",
  discardDraft: "users/{userId}/claim/remove-claim?claimNumber={claimNumber}",
  removeEntryFromCart:
    "users/{userId}/quotes/{quoteCode}/{entryNumber}/quoteCartEntryRemove",
  actionOnQuote: "users/{userId}/quotes/{quoteCode}/quoteActions",
  updateQuoteQuantity:
    "users/{userId}/quotes/{quoteCode}/quoteEntryQuantityUpdate",
  reqDeliveryDate: "users/{userId}/getReqDeliveryDates",
  currentOrdersCount: "users/{userId}/currentOrdersCount",
  sampleOrderCount: "users/{userId}/sampleOrderCount",
  claimsCount: "users/{userId}/claimsCount",
  invoiceCountForUnit: "users/{userId}/invoiceCountForUnit",
  reserveCountForUnit: "users/{userId}/reserveCountForUnit",
  todayShipmentCountForUnit: "users/{userId}/todayShipmentCountForUnit",
  quoteCount: "users/{userId}/currentQuotesCount",
  postOrderModification: "users/{userId}/postOrderModification",
  compareProduct: "products/compareProducts",
  setUnit: "users/{userId}/orgCustomers/setDefaultUnit",
  orderCancel: "users/{userId}/orderCancel/{entryNumber}",
  CancelReason: "users/{userId}/getSecndryAttributes?secAttrType={type}",
  getDivisions: "users/{userId}/carts/{cartId}/divInfo",
  getSubDivisions: "users/{userId}/carts/{cartId}/subDivInfo",
  submitBuilderInfo: "users/{userId}/carts/{cartId}/submitBuilderInfo",
  clearB2BUnit: "users/{userId}/orgCustomers/clearB2BUnit?isCSR=true",
  updateProfile: "users/{userId}/profile",
  setProfile: "orgUsers/{userId}",
  validatePassKey: "users/{userId}/validatePassKey",
  requestingNewPrice:
    "users/{userId}/carts/{cartId}/entries/{entryNumber}/changePrice?requestedPrice={requestedPrice}&priceComment={priceComment}",
  getShippingMethod:
    "orgUsers/{userId}/getShippingMethod?zipCode={code}&isCustomer={isCustomer}&isOneTimeShipTo={isOneTimeShipTo}&shippingMethod={shippingMethod}",
  getShippingWareHouse: "/users/{userId}/getShippingWarehouses",
  updateShippingMethod:
    "/orgUsers/{userId}/updateShippingMethod?code={code}&shipCode={shipCode}",
  updateShippingWareHouse:
    "/users/{userId}/updateShippingWareHouse?code={code}&shipCode={shipCode}",
  getMinMaxRollLength: "products/getMinMaxRoll?targetLength={standardRollLength}&productCode={productCode}&shipTo={shipTo}&soldTo={soldTo}&uom={uom}",
  poAttachment: "/{userId}/fileupload/",
  orderEntries: "/users/{userId}/getPostOrderUpdateEntriesModifications",
  reserveToCart: "reserve/users/{userId}/reserveToCart",
  addLineOrAccessories: "users/{userId}/addLineOrAccessories",
  getShippingMethodWithOutFlag:
    "/orgUsers/{userId}/getShippingMethod?zipCode={code}",
  getShippingWareHouseWithOutFlag: "/users/{userId}/getShippingWareHouse",
  updateShippingMethodWithOutFlag:
    "/orgUsers/{userId}/updateShippingMethod?code={code}&shipCode={shipCode}",
  updateShippingWareHouseWithoutFlag:
    "/orgUsers/{userId}/updateShippingWareHouse?code={code}&shipCode={shipCode}",
  postOrderEligibility: "users/{userId}/postOrderEligibility/{code}",
  getQuoteData: "users/{userId}/quotes/{code}/edit",
  endUserList: "orgUnits/{uid}/endUserList?searchText={search}",
  getSalesHierarchy: "user/{userId}/salesHierarchy",
  getChildHierarchy: "/user/{userId}/childHierarchy",
  getsalesListAccounts: "users/{userId}/selectAccount/salesListAccounts",
  getsalesOpsListAccounts: "users/{userId}/selectAccount/salesOpsListAccounts",
  getSalesTeam: "account/{accountId}/salesTeam",
  uploadFile: "users/{userId}/fileupload",
  updateQuoteShippingAddress:
    "users/{userId}/quotes/{quoteCode}/updateQuoteShippingAddress",
  getQuoteSolutions: "users/{userId}/quotes/{quoteCode}/getQuoteSolutions",
  addToQuote: "users/{userId}/quotes/{quoteCode}/{entry}/addToQuote",
  quoteCheckout: "users/{userId}/quotes/{quoteCode}/quoteCheckout",
  quoteListFilter: "users/{userId}",
  accountSearch: "users/{userId}/orgCustomers/findCustomers?searchCustomerId=",
  placeQuoteOrder: "users/{userId}/quotes/{quoteCode}/placeQuoteOrder",
  addDocument: "users/{userId}/claim/add-document",
  mashup: "users/{email}/mashup/validation",
  addComment: "users/anonymous/claim",
  getVendorAccountNumbers:
    "users/{userId}/getVendorAccountNumbers?shipTo={shipTo}&soldTo={soldTo}",
  getZoneZipcodeDetermination:
    "users/{userId}/getZoneZipcodeDetermination?zipcode={zipcode}",
  getVendorAccountNumbersForOrder:
    "users/{userId}/getVendorAccountNumbers/{orderNumber}/{lineNumber}",
  getAllSamples: "products/getAllSamples/{productCode}",
  replaceProduct: "users/{userId}/quotes/replaceProduct?",
  getVendorAccountNumbersForOrderV2:
    "users/{userId}/getVendorAccountNumbersForOrder/{productCode}/{lineNumber}",
  getQuoteAdhesives: "users/{userId}/quotes/{quoteId}/getQuoteAdhesives",
  addAccessoriesQuote:
    "users/{userId}/quotes/addMultiAccessoriesToQuoteDetails?fields=FULL",
  pricingDownload: "users/{userId}/pricing/pdp-price-search?accountNumber=", // NOT OK
  priceSearch: "users/{userId}/pricing/price-search?accountNumber=",
  samplePriceSearch: "users/{userId}/pricing/sample-price-search?accountNumber=",
  getIncoTerms: "users/{userId}/incoTerms?shippingMethod={shippingMethod}",
  validateSMATPReq:"users/{userId}/isShippingMethodReAtpRequired?shippingConditionFrom={shippingMethodFrom}&shippingConditionTo={shippingMethodTo}",
  validateShipVia:
    "users/{userId}/validateShipVia?shippingMethod={shippingMethod}&shipVia={shipVia}",
  validateShippingOptions:
  "users/{userId}/validateShippingOptions?incoLocation={incoTerm}&productCat={productCategory}&shipVia={shipVia}",
  getShippingOptions:
    "users/{userId}/getShippingOptions?fields=DEFAULT&isSample={isSample}&productCode={productCode}&shipTo={shipTo}&soldTo={soldTo}",
  getIncoTermsLoc2:
    "users/{userId}/getShipviaList?incotermsLocation1={incotermsLocation1}&zipCode={zipCode}&shippingMethod={shippingMethod}",
  samplesInventoryCheck: "sampleOrder/samplesInventoryCheck?fields=DEFAULT",
  getSmallParcelCarriers: "users/{userId}/getSmallParcelCarriers",
  updateSmallParcelFields: "carts/{cartId}/updateSmallParcelFields",
  validateShipperAccount:
    "users/{userId}/carts/{cartId}/validateShipperAccount?zipcode={zipCode}&accountNumber={accoundNum}&carrierType={carrierID}",
  getCustomerList: "customerlists",
  listAutocomplete: "customers/autocomplete",
  emulateCustomer: "emulateCustomer",
  getCustomersFromList: "customers/search",
  bindAnonymousCart: "bind-cart",
  stopSession: "end-emulation",
  shipToAddresses: "users/{userId}/invoices/shipToAddresses",
  updateNotifications: "users/{userId}/orgCustomers/updateNotifications",
  profileShippingPreferences: "users/{userId}/orgCustomers/shippingAddress",
  setDefaultStorefront:
    "users/{userId}/orgCustomers/setDefaultStorefront?defaultStorefront={defaultStorefront}",
  noChargeReasonCodes:
    "users/{userId}/getSecndryAttributes?secAttrType=NO_CHARGE_REASON_CODE",
  removeFile: "users/{userId}/removefile",
  entitlementMgrFilters: "products/entitlementMgrCustomFilters",
  getentitlementMgrList: "products/entitlementMgrSearch",
  updateCustomerEntitlement: "products/updateCustEntitlement",
  addMultiAccessoriesToQuoteCart:
    "users/{userId}/quotes/addMultiAccessoriesToQuoteCart?fields=FULL",
  cloneOrderAddToCart:
    "carts/users/{userId}/sampleCloneOrder?sampleOrderNumber={sampleOrderNum}&shipTo={shipToId}",
  cloneOrdersValidation:
    "users/{userId}/orders/isValidSampleOrder?sampleOrderCode={sampleOrderCode}&accountList={accountList}",
  validateSmallParcel: "carts/{cartId}/validateCartForSmallParcel",
  smallParcelShippingCondition:
    "users/{userId}/getSmallParcelShippingConditions?carrier={carrierId}",
  getCompaniesList:
    "users/anonymous/orgCustomers/populateCompanies?selectedAccount={selectedAccount}",
  advancedProductsSearch: "products/advancedSearch",
  salesHierarchyforSalesOps: "user/{userId}/salesHierarchyforSalesOps",
  updatePostOrderEntry: "users/{userId}/updatePostOrderEntry",
  colorVariants: "/users/{userId}/quotes/colorVariants/{code}",
  plpPriceSearch: "users/{userId}/pricing/plp-price-search?accountNumber={uid}",
  getTermsCodeList: "users/{userId}/getTermsCodeList",
  setDefaultAddress:
    "users/{userId}/orgCustomers/setDefaultAddress?addressId={addressId}",
  accessoryPriceSearch: "users/{userId}/pricing/accessory-price-search?accountNumber=",
  pricingGetCollectionsList:
    "users/{userId}/pricing/getCollectionsList?accountNumber={accountNumber}",
  populateEmailsForAutoComplete:
    "users/{userId}/orgCustomers/populateEmailsForAutoComplete",
    getFromTmNumbers:
    "sample-budget-allocation/users/{userId}/getFromTmNumbers?searchText={searchText}&isFutureBudget={isFutureBudget}&currency={currency}",
  getToTMNUmbers:
    "sample-budget-allocation/users/{userId}/getToTmNumbers?searchText=",
  getPricingBrands: "users/{userId}/pricing/getPricingBrands?productCategory=",
  hasCrossOver: "products/hasCrossOvers/{ProductCode}",
  getcrossOver: "products/getCrossOvers/{ProductCode}",
  paymentTermsList: `users/{userId}/getTermsCodeList?isSampleProduct={isSampleProduct}
    &merchandisingProduct={merchandisingProduct}&cartId={cartId}&orderId={orderId}`,
  potentialMatches: "users/{userId}/quotes/{quoteId}/potentialmatches",
  gpoList: "orgUnits/{uid}/gpoList?searchText={search}",
  creList: "orgUnits/{uid}/creList?searchText={search}",
  adList: "orgUnits/{uid}/adList?searchText={search}",
  isShippingMethodReAtpRequired:"users/{userId}/isShippingMethodReAtpRequired?shippingConditionFrom={shippingConditionFrom}&shippingConditionTo={shippingConditionTo}",
  getShippingoptionForCustomers:
    "users/{userId}/shippingOptionsForCustomer?zipCode={code}&shippingCondition={shippingCondition}&shippingWarehouse={shippingWareHouse}&isOneTimeShipTo={isOneTimeShipTo}&b2bUnitId={b2bUnitId}",
  getSampleBudgetForCart: "carts/{cartId}/users/{userId}/getSampleBudgetForCart",
  getDefaultUnit: "users/{userId}/orgCustomers/getDefaultUnit",
  validatePromoCode: "users/{userId}/validatePromoCode?promoCode={code}",
  pricingAllAddress: "users/{userId}/pricing/getAllAddresses?pageSize={pageSize}&currentPage={currentPage}&fields=DEFAULT&searchText={searchText}",
  merchandisingPriceDetails: "users/{userId}/pricing/{productCode}/merchandisingPriceDetails?fields=FULL",
  salesHierarchyforSalesManager: "user/{userId}/salesHierarchyForMgr",
  removeATPCartEntry : "users/{userId}/removeATPCartEntry",
  myApprovalClaimsCount: "users/{userId}/claim/myApprovalClaimsCount",
  claimsApprovalList : "users/{userId}/claim/myApprovalClaims",
  claimApproveReject:"users/{userId}/claim/approval ",
  getSubProductTypeList: "users/{userId}/getSubProductTypeList?productType={productType}",
  getBundledReferences: "products/getBundledReferences/{productCode}",
   virtualServicesAddressValidate: "users/{userId}/camsAddressValidation",
};
